import type { JSX } from 'react'
import type { Country, EmbeddedFlagProps, Flags } from 'react-phone-number-input'
import phoneFlags from 'react-phone-number-input/flags'

// Matches --PhoneInputCountryFlag-height (1rem) and the library's 3:2 aspect ratio
const FLAG_WIDTH = 24
const FLAG_HEIGHT = 16

type SizedFlagProps = EmbeddedFlagProps & { width: number, height: number }

/**
 * The bundled flag SVGs only carry a viewBox; Safari renders them at zero size without
 * explicit width/height attributes, so forward fixed dimensions to every flag component.
 */
export const sizedPhoneFlags: Flags = Object.fromEntries(
  (Object.entries(phoneFlags) as Array<[Country, (props: SizedFlagProps) => JSX.Element]>)
    .map(([country, Flag]) => [
      country,
      (props: EmbeddedFlagProps) => <Flag {...props} width={FLAG_WIDTH} height={FLAG_HEIGHT} />
    ])
)
